import { ApiClientError } from '../../models/api/api-envelope';
import { ApiLocation, Location, LocationsResponse } from '../../models/api/location';

function isValidLocation(location: ApiLocation): boolean {
  return !!location &&
    (typeof location.idlocacion === 'string' || typeof location.idlocacion === 'number') &&
    typeof location.nombre === 'string' &&
    location.nombre.length > 0;
}

export function mapLocationsResponse(response: LocationsResponse): Location[] {
  if (!response || Number(response.code) !== 0) {
    throw new ApiClientError('locations', 'No fue posible obtener las locaciones.');
  }
  if (!Array.isArray(response.locaciones) || !response.locaciones.every(isValidLocation)) {
    throw new ApiClientError('invalid-response', 'La respuesta de locaciones no es válida.');
  }
  return response.locaciones.map(function (location) {
    return { idlocacion: location.idlocacion, nombre: location.nombre, activo: '' };
  });
}



// WEBPACK FOOTER //
// ./src/providers/locations/location-mapper.ts